interface IHttpHeaderConfig {
    type: number
}
const config: IHttpHeaderConfig = {
    type: 0
}
export default config